import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";
import ConfigProvider from "antd/es/config-provider";
import React, { useEffect, useState } from "react";

const LoadingPage = () => {
  const customIcon = (
    <LoadingOutlined
      style={{
        fontSize: "200px", // Custom size for the spinning icon
        // color: "#ff69b4", // Pink color for the spin icon
        color: "#6499f1", // Pink color for the spin icon
        // borderColor: "#ff69b4", // Pink color for the border
        borderColor: "#6499f1", // Pink color for the border
      }}
    />
  );

  // Centering the spin component using flexbox
  const containerStyle = {
    display: "flex",
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
    height: "100vh", // Full screen height
    background: "rgba(256, 192, 203, 0.05)", // Light pink background
    borderRadius: 4,
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Spin: {
            contentHeight: 100,
          },
        },
      }}
    >
      <div style={containerStyle}>
        <Spin
          tip="Loading"
          size="small"
          indicator={customIcon} // Set custom icon as the spinning indicator
        />
      </div>
    </ConfigProvider>
  );
};
export default LoadingPage;
